import React from "react";

// Classnames
import clsx from "clsx";

// Iterface
interface INoData {
  text?: string,
  className?: string,
}

export const NoData: React.FC<INoData> = ({ text, className }) => {
  const cn = clsx(
    "no-data mb10 mt10",
    className ? className : ""
  );
  return (
    <p className={cn}>
      {text ? text : "No data yet"}
    </p>
  );
};

export default NoData;
